import { render } from "./DataDeletionIcon.vue?vue&type=template&id=9fa63da0&scoped=true"
import script from "./DataDeletionIcon.vue?vue&type=script&lang=js"
export * from "./DataDeletionIcon.vue?vue&type=script&lang=js"

import "./DataDeletionIcon.vue?vue&type=style&index=0&id=9fa63da0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa63da0"]])

export default __exports__